/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TriState {
    NO = 'no',
    YES = 'yes',
    UNKNOWN = 'unknown',
}
